export default __webpack_public_path__ + "static/media/listings_active.bdf0167e.svg";